import { ConcreteEncodable } from "./ConcreteEncodable";

import { StrategyModificationLockResponseImplEncoder } from "../../encoder/StrategyModificationLockResponseImplEncoder";

import * as CubiqTS from "../../index";
import { StrategyModificationLockResponse } from "../StrategyModificationLockResponse";

export class StrategyModificationLockResponseImpl
  extends ConcreteEncodable
  implements StrategyModificationLockResponse
{
  public static enType: string = "com.bcdfx.model.StrategyModificationLockResponseImpl";

  /*FID=1*/
  public lockErrors: CubiqTS.Errors | null = null;
  /*FID=2*/
  public orderData: Array<CubiqTS.OrderData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StrategyModificationLockResponseImplEncoder.Instance;
    this.setEncodableType(StrategyModificationLockResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StrategyModificationLockResponseImpl[" +
      "lockErrors=" +
      this.lockErrors +
      "orderData=" +
      this.orderData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
